import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

/**
 * Layout route for /assessments/:templateId/*. Renders <Outlet /> so child
 * routes (`/` index = detail, `/assign`, `/bulk-assign`) can mount here.
 * If this returned the detail screen directly, the assign + bulk-assign
 * children would silently fail to render — same fix Modules 1-3 needed.
 */
export const Route = createFileRoute('/_staff/admin/workspace/assessments/$templateId')({
  beforeLoad: () => {
    requirePermission('assessment:read');
  },
  component: WorkspaceAssessmentLayout,
  staticData: { crumb: 'Template' },
});

function WorkspaceAssessmentLayout() {
  return <Outlet />;
}
